<template>
    <div class="modal modal--rebrand fade over-all modal-with-custom-content modal-with-custom-content--dark-background"
         id="modalNotLoggedIn" tabindex="-1" role="dialog"
         aria-labelledby="modalNotLoggedInTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-content-tabs">
                    <button @click.prevent="changeTab('register')" :class="{'active': isRegisterActive}">
                        {{ translate.login.modalRegisterGallery.register }}
                    </button>
                    <button @click.prevent="changeTab('login')" :class="{'active': isLoginActive}">
                        {{ translate.login.login }}
                    </button>
                </div>

                <div class="modal-body" v-if="isModalOpen && isRegisterActive">
                    <h5 class="heading mb-2" v-html="translate.home.registrationModal.registerForFree"></h5>
                    <p class="subheading mb-2">{{ translate.home.registrationModal.withFreeAccountYouGet }}</p>
                    <ul class="d-flex flex-column gap-2 mb-3">
                        <li v-for="(item, index) in translate.home.registrationModal.advantagesList" :key="index">
                            <icon-component :icon="checkmarkDouble()" />
                            {{ item }}
                        </li>
                    </ul>
                    <punter-registration-component @successRedirect="onRegistrationSuccess"/>
                </div>

                <div class="modal-body" v-if="isModalOpen && isLoginActive">
                    <h5 class="heading mb-2">{{ translate.login.login }}</h5>
                    <p class="subheading mb-3">{{ translate.login.signInToYourAccount }}</p>

                    <punter-login-component @successRedirect="onLoginSuccess"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import regionsUrlMixin from "@/components/mixins/regions/regionsUrlMixin";
import localStorageMixin from "@/components/mixins/localStorageMixin";
import PunterRegistrationComponent from "@/components/users/auth/PunterRegistrationComponent";
import PunterLoginComponent from "@/components/users/auth/PunterLoginComponent";
import IconComponent from "@/components/global/IconComponent.vue";
import {checkmarkDouble} from "@/core/constants/icons";

function mounted() {
    $('#modalNotLoggedIn').on('show.bs.modal', () => {
        this.isModalOpen = true;
    });
}

export default {
    components: {
        IconComponent,
        PunterLoginComponent,
        PunterRegistrationComponent,
    },
    data() {
        return {
            activeTab: 'register',
            isModalOpen: false,
        };
    },
    methods: {
        checkmarkDouble,
        changeTab(tab) {
            this.activeTab = tab;
        },
        onRegistrationSuccess() {
            $('#modalNotLoggedIn').modal('hide');
            this.setPaymentRedirectLink(window.location.href);
            window.location.href = this.regionRelativeUrl('/client/onboarding/');
        },
        onLoginSuccess() {
            $('#modalNotLoggedIn').modal('hide');

            window.location.reload();
        },
    },
    computed: {
        ...mapState(['translate']),
        isRegisterActive() {
            return this.activeTab === 'register';
        },
        isLoginActive() {
            return this.activeTab === 'login';
        },
    },
    mixins: [
        regionsUrlMixin,
        localStorageMixin,
    ],
    mounted,
    beforeDestroy() {
        $('#modalNotLoggedIn').off('show.bs.modal');
        window.clearModalFade();
    },
};
</script>
